<script>
  import { onDestroy, onMount } from "svelte";
  import { injectAuditLogCss } from "../lib/gruimModuleTheme";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import GrappleAuditLogTable from "../components/auditLogTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let elDashboard;
  let auditLogDashboardInstance = null;

  const mountGrappleAuditLogDashboard = async () => {
    try {
      const module = await import("App/auditLogDashboard");
      const GrappleAuditLogDashboard = module.default;

      if (elDashboard) {
        auditLogDashboardInstance = mountFederatedSvelteComponent(
          auditLogDashboardInstance,
          GrappleAuditLogDashboard,
          { target: elDashboard }
        );
      }
    } catch (err) {
      console.warn("auditLogDashboard module unavailable:", err);
    }
  };

  onMount(() => {
    injectAuditLogCss();
    void mountGrappleAuditLogDashboard();
  });

  onDestroy(() => {
    auditLogDashboardInstance = destroySvelteComponentInstance(auditLogDashboardInstance);
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule audit-log-dark" bind:this={elDashboard} />
    <div class="uimodule">
      <GrappleAuditLogTable />
    </div>
  </div>
</PageContainer>
